export const FETCH_USER_DATA_REQUEST = 'page/FETCH_USER_DATA_REQUEST';
export const FETCH_USER_DATA_SUCCESS = 'page/FETCH_USER_DATA_SUCCESS';
export const FETCH_USER_DATA_FAILURE = 'page/FETCH_USER_DATA_FAILURE';
export const SET_USER_ID_FAILURE = 'page/SET_USER_ID_FAILURE';
export const SET_USER_ID = 'page/SET_USER_ID';
